import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";

import Home from "./pages/Home";
import Assessment from "./pages/Assessment";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Login from "./pages/Login";
import FounderLayout from "./pages/founder/FounderLayout";
import Dashboard from "./pages/founder/Dashboard";
import Businesses from "./pages/founder/Businesses";
import Workspace from "./pages/founder/Workspace";
import BlueprintPreview from "./pages/founder/BlueprintPreview";
import FollowUps from "./pages/founder/FollowUps";
import ExportData from "./pages/founder/ExportData";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === undefined)
    return <div className="min-h-screen flex items-center justify-center text-lr-leather">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/assessment/:token" element={<Assessment />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/login" element={<Login />} />
            <Route path="/app" element={<Protected><FounderLayout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="businesses" element={<Businesses />} />
              <Route path="businesses/:bid" element={<Workspace />} />
              <Route path="businesses/:bid/blueprint/preview" element={<BlueprintPreview />} />
              <Route path="follow-ups" element={<FollowUps />} />
              <Route path="export" element={<ExportData />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
